import type { ReactNode } from 'react';

export interface CompactRowProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned meta (chips, controls). */
  meta?: ReactNode;
  /** Leading element (icon/checkbox). */
  lead?: ReactNode;
  onClick?: () => void;
}

/** The workhorse list item: dense, scannable, optionally interactive. */
export function CompactRow({ title, subtitle, meta, lead, onClick }: CompactRowProps) {
  const interactive = Boolean(onClick);
  return (
    <div
      className="lc-row"
      data-interactive={interactive}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
    >
      {lead}
      <div className="lc-row__main">
        <div className="lc-row__title">{title}</div>
        {subtitle ? <div className="lc-row__sub">{subtitle}</div> : null}
      </div>
      {meta ? <div className="lc-row__meta">{meta}</div> : null}
    </div>
  );
}
